module.exports = __webpack_public_path__ + "img/idticon.6498b326.svg";